export function validatePhoneNumber(phone) {
  if (!/^[0-9+]+$/.test(phone)) {
    return 'Invalid phone number';
  } else if (phone.length !== 10) {
    return 'Phone number must be exactly 10 digits';
  }
  return '';
}

export function validateEmails(email, confirmEmail) {
  if (!/^\S+@\S+\.\S+$/.test(email)) {
    return 'Invalid email address';
  } else if (email !== confirmEmail) {
    return 'Emails do not match';
  }
  return '';
}

export function validateAddress(address) {
  if (address.trim() === '') {
    return 'Address cannot be empty';
  }
  return '';
}


// form 2
export function validatePercentage(percentage) {
  if (percentage === '' || parseFloat(percentage) > 100) {
    return 'Percentage cannot be greater than 100';
  }
  return '';
}

// form 2

export function validateInstituteName(name) {
  const specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if (specialCharacters.test(name)) {
    return 'Institute name cannot contain special characters';
  }
  return ''; // Return an empty string when the input is valid
}

export function validateSchoolName(schoolName) {
  const specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if (specialCharacters.test(schoolName)) {
    return 'Institute name cannot contain special characters';
  }
  return ''; // No error message if validation passes
}

export function validateStartDate12(startDate, endDate) {
  if (startDate > endDate) {
    return "Start date cannot be greater than end date";
  }
  return ""; // No validation error
}

// Function to validate the end date (Class 12th)
export function validateEndDate12(endDate, startDate) {
  if (endDate < startDate) {
    return "End date cannot be less than start date";
  }
  return ""; // No validation error
}

// Function to validate the start date (Class 10th)
export function validateStartDate10(startDate, endDate) {
  if (startDate > endDate) {
    return "Start date cannot be greater than end date";
  }
  return ""; // No validation error
}

// Function to validate the end date (Class 10th)
export function validateEndDate10(endDate, startDate) {
  if (endDate < startDate) {
    return "End date cannot be less than start date";
  }
  return ""; // No validation error
}